import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  Col,
} from "reactstrap";
import { FaSpinner } from 'react-icons/fa';

import Logo from "components/Logo";
import AuthFooter from "components/Footers/AuthFooter";
import { login } from "network/ApiAxios";
import { useAuth } from "contexts/AuthContext";
import AuthAnimation from "./AuthAnimation";

const LOGIN_GENERIC_ERROR = "We couldn't sign you in. Please try again.";
const IS_SUBSCRIBER = true;


const Login = () => {
  const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { status, signIn } = useAuth();

  useEffect(() => {
    if (status === "authenticated") {
      navigate('/c/');
    }
  }, [navigate, status]);

  const tryLogin = async (e) => {
    e.preventDefault();

    if (isLoading) {
      return;
    }

    if (!email.trim() || !password.trim()) {
      setError("Email & password are required.");
      return;
    }

    setError("");
    setIsLoading(true);

    try {
      const data = await login(email.trim(), password, IS_SUBSCRIBER);

      if (data?.success && data.user) {
        signIn(data.user);
        return;
      }

      setPassword("");
      setError(data?.msg || LOGIN_GENERIC_ERROR);
    } catch (err) {
      if (err?.code === "ECONNABORTED" || err?.code === "ETIMEDOUT") {
        setError("Sign-in is taking longer than expected. Please check your connection and try again.");
      } else {
        setError("We couldn't reach the sign-in service. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Col xl="5" lg="5" md="7" className="d-flex flex-column mx-lg-0 mx-auto">
        <Logo />
        <Card className="card-plain">
          <CardHeader className="pb-0 text-start">
            <h4 className="font-weight-bolder text-29334A">Sign In</h4>
            <p className="text-black">Log in to Bevan.ai using your existing Intelligence credentials. Only subscribers on <a className="link-primary text-decoration-underline" href="https://futurehealthintelligence.com/subscription-options/" target="_blank" rel="noopener noreferrer">eligible packages</a> will have access.</p>
            <p className="mb-0 d-none">Enter your email and password to sign in</p>
          </CardHeader>
          <CardBody>
            <Form role="form" onSubmit={tryLogin}>
              <FormGroup className="mb-3">
                <Input
                  className="form-control-lg"
                  name="email"
                  placeholder="Email"
                  type="email"
                  autoComplete="email"
                  onChange={e => setUsername(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  className="form-control-lg"
                  name="password"
                  placeholder="Password"
                  type="password"
                  autoComplete="password"
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </FormGroup>

              {error && (
                <div className="text-muted font-italic">
                  <small>
                    <span className="text-danger fw-700">{error}</span>
                  </small>
                </div>
              )}
              <div className="text-center">
                <Button type="submit" disabled={isLoading} className="btn-lg btn-primary btn-lg w-100 mt-4 mb-0" color="custom">
                  {isLoading ? <FaSpinner className="icon-spin" /> : 'Sign in'}
                </Button>
              </div>
            </Form>
          </CardBody>
          <CardFooter className="text-center pt-0 px-lg-2 px-1">
            <p className="mb-2 text-sm mx-auto">
              Forgot password?
              <a href="https://futurehealthintelligence.com/reset-password/" className="text-custom text-gradient font-weight-bold" target="_blank" rel="noopener noreferrer"> Reset here!</a>
            </p>
             <p className="mb-2 text-sm mx-auto">
              Want to explore Bevan.ai? Request a demo at 
              <a href="mailto:intelligence@futurehealthintelligence.com" className="text-custom text-gradient font-weight-bold"> intelligence@futurehealthintelligence.com</a>
            </p>
          </CardFooter>
        </Card>

        <AuthFooter />
      </Col>

      <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-left flex-column">
        <div className="position-relative bg-gradient-dark h-100 m-3 border-radius-lg d-flex flex-column overflow-hidden" >
          <AuthAnimation />
        </div >
      </div >
    </>
  );
};

export default Login;
